import React from 'react';
import { IconProps } from '../types';

interface CustomIconProps extends IconProps {
  viewBox?: string;
  role?: string;
  'aria-hidden'?: boolean;
}

export const SsfShortformOff = React.memo<CustomIconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
    width,
    height,
    role = 'img',
    'aria-hidden': ariaHidden = false,
  }) => (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? size}
      height={height ?? size}
      className={className}
      onClick={onClick}
      role={role}
      aria-hidden={ariaHidden}
      style={{ cursor: onClick ? 'pointer' : 'inherit' }}
    >
      <path
        d="M3 16H17"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 6.91998C9 6.58356 9.35646 6.38414 9.62017 6.57305L11.8258 8.15306C12.0581 8.3194 12.0581 8.68059 11.8258 8.84694L9.62017 10.427C9.35646 10.6159 9 10.4164 9 10.08V6.91998Z"
        fill="white"
      />
      <rect
        x="3"
        y="4"
        width="14"
        height="9"
        rx="1"
        stroke="white"
        strokeWidth="1.2"
      />
    </svg>
  ),
);

SsfShortformOff.displayName = 'SsfShortformOff';
